import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import './Sidebar.css'
import useSidebar from './hooks/useSidebar'

export default function SideBar() {
  const { sidebarLinks } = useSidebar()

  const listElement = React.useRef(null)
  const selectedItemCaretHeight = 35
  const expandedSidebarWidth = 205
  const collapsedSidebarWidth = 90
  const toCollapseButtonIcon = './icons/collapse.svg'
  const toExpandButtonIcon = './icons/expand.svg'

  const [sidebarWidth, setSidebarWidth] = useState(expandedSidebarWidth)
  const [yoffset, setYoffset] = useState()
  const [currentlySelectedItem, setCurrentlySelectedItem] = useState(-1)
  const [collapseExpandButtonIcon, setCollapseExpandButtonIcon] =
    useState(toCollapseButtonIcon)
  const [sidebarExpanded, setSidebarExpanded] = useState(true)

  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    let index = -1
    const pathComponents = location.pathname.split('/')
    for (let i = 0; i < sidebarLinks.length; i++) {
      // Skip section labels
      if (sidebarLinks[i].sectionLabel) continue

      if (pathComponents.length > 1) {
        for (let j = 1; j < pathComponents.length; j++) {
          if (
            sidebarLinks[i].selectedIfMatchesRoutes?.includes(
              '/' + pathComponents[j]
            )
          ) {
            index = i
            break
          }
        }
      } else {
        index = 0
      }
      if (index === i) {
        break
      }
    }
    if (index !== -1) {
      setCurrentlySelectedItem(index)
      if (listElement.current?.children[index]) {
        updateCaret(listElement.current.children[index])
      }
    } else {
      setCurrentlySelectedItem(null)
      setYoffset(-100)
    }
  }, [location, sidebarLinks])

  function handleSidebarItemClick(e, item) {
    if (item.route === '/faq') {
      window.open('https://artists.feelsmusic.com/help', '_blank').focus()
    } else {
      updateCaret(e.target)
      navigate(item.route)
    }
  }

  function updateCaret(element) {
    if (element !== undefined) {
      const rect = element.getBoundingClientRect()
      const height = rect.bottom - rect.top
      setYoffset(rect.top - (selectedItemCaretHeight - height) / 2)
    }
  }

  function handleCollapse() {
    if (sidebarExpanded) {
      setSidebarExpanded(false)
      setSidebarWidth(collapsedSidebarWidth)
      setCollapseExpandButtonIcon(toExpandButtonIcon)
      const main = document.getElementById('main')
      main.style.transition = '0.5s'
      main.style.marginLeft = collapsedSidebarWidth + 'px'
      main.style.width = 'calc(100% - ' + collapsedSidebarWidth + 'px)'
      const navbar = document.getElementById('navbar')
      navbar.style.transition = '0.5s'
      navbar.style.left = collapsedSidebarWidth + 'px'
    } else {
      setSidebarExpanded(true)
      setSidebarWidth(expandedSidebarWidth)
      setCollapseExpandButtonIcon(toCollapseButtonIcon)
      const main = document.getElementById('main')
      main.style.transition = '0.5s'
      main.style.marginLeft = expandedSidebarWidth + 'px'
      main.style.width = 'calc(100% - ' + expandedSidebarWidth + 'px)'
      const navbar = document.getElementById('navbar')
      navbar.style.transition = '0.5s'
      navbar.style.left = expandedSidebarWidth + 'px'
    }
  }

  return (
    <>
      <div
        id="sidebar"
        style={{
          width: `${sidebarWidth}px`,
          transition: '0.5s',
        }}
      >
        <button id="sidebar-btn-collapse-expand" onClick={handleCollapse}>
          <img
            width="24"
            height="24"
            src={require(`${collapseExpandButtonIcon}`)}
            alt="expand"
          />
        </button>
        <div
          id="sidebar-cursor-selected-item"
          style={{
            position: 'absolute',
            height: `${selectedItemCaretHeight}px`,
            top: `${yoffset}px`,
            transition: 'top 0.5s',
            opacity: sidebarLinks.length ? 1 : 0,
          }}
        ></div>
        <nav>
          <ul ref={listElement}>
            {sidebarLinks.length &&
              sidebarLinks.map((item, idx) => {
                // Section label
                if (item.sectionLabel) {
                  return sidebarExpanded ? (
                    <div key={`section-${idx}`} className="sidebar-section-label">
                      {item.sectionLabel}
                    </div>
                  ) : (
                    <div key={`section-${idx}`} className="sidebar-section-divider" />
                  )
                }

                // Regular nav item
                return (
                  <div key={item.index}>
                    <li>
                      <div
                        id="vertical-aligned-li"
                        onClick={e => handleSidebarItemClick(e, item)}
                      >
                        <img
                          width={item.alt === 'codes' ? '28' : '24'}
                          height={item.alt === 'codes' ? '28' : '24'}
                          className={item.index === currentlySelectedItem ? 'sidebar-icon-active' : 'sidebar-icon'}
                          src={require(`${item.iconUnselected}`)}
                          alt={item.alt}
                        />
                        {sidebarExpanded && (
                          <span
                            id={
                              item.index === currentlySelectedItem
                                ? 'sidebar-text-item-selected'
                                : 'sidebar-text-item-unselected'
                            }
                          >
                            {item.name}
                          </span>
                        )}
                      </div>
                    </li>
                  </div>
                )
              })}
          </ul>
        </nav>
      </div>
    </>
  )
}
